if (!customElements.get('scp-search')) {
  customElements.define('scp-search',
    class SCPSearch extends HTMLElement {
      constructor() {
        super();
        this.consultantNameForm = this.querySelector('#scp-search-name');
        this.consultantZipForm = this.querySelector('#scp-search-zip');
        this.resultsContainer = this.querySelector('.scp-search__results');
        this.totalCountElement = this.querySelector('.scp-search__total-count');
        this.currentCountElement = this.querySelector('.scp-search__current-count');
        this.totalCount = 0;
        this.currentCount = 0;
        this.searchFormContainer = this.querySelector('.scp-search__forms');
        this.searchAgainButton = this.querySelector('.scp-search__search-again');
        this.loadMoreButton = this.querySelector('.scp-search__load-more .button');
        this.errorMessage = this.dataset.errorMessage;
        this.resultLimit = this.dataset.resultLimit;
        this.pageInfo = null;
        this.filter = {};
        this.popStateHandler = this.onPopState.bind(this);
        this.noResultsTemplate = this.querySelector('#no-results-template');
      }
      
      connectedCallback() {
        if (!window.location.pathname.endsWith(this.dataset.pageUrl)) {
          history.replaceState(null, "", `${window.location.protocol}//${window.location.host}${this.dataset.pageUrl}`);
        }
        [this.consultantNameForm, this.consultantZipForm].forEach((form) => {
          form.addEventListener('submit', this.submit.bind(this));
          form.querySelector('input').addEventListener('input', (e) => {
            if (e.target.value === '' || !e.target.value) {
              form.querySelector('button').setAttribute('disabled', true);
            } else {
              form.querySelector('button').removeAttribute('disabled');
            }
          });
          setTimeout(() => {
            if (form.querySelector('input').value !== '') {
              form.querySelector('button').removeAttribute('disabled');
            }
          }, 1)
        });

        const searchParams = new URLSearchParams(window.location.search);
        const allowedSearchParams = ['query', 'zip'];
        const activeSearchParams = allowedSearchParams.filter(key => searchParams.get(key) !== null);

        if (activeSearchParams.length > 1 || searchParams.get(activeSearchParams[0]) == '') {
          history.replaceState(null, "", `${window.location.protocol}//${window.location.host}${this.dataset.pageUrl}`);
          activeSearchParams.forEach(key => {
            searchParams.delete(key);
          });
        }

        allowedSearchParams.forEach(key => {
          if (searchParams.get(key)) {
            this.resultsContainer.removeAttribute('hidden');
            this.searchFormContainer.setAttribute('hidden', true);
            this.querySelector(`input[name=${key}]`).value = searchParams.get(key);
            setTimeout(() => {
              this.querySelector(`input[name=${key}]`)?.form?.querySelector('button')?.click(); 
            }, 1);
          }
        });
        
        this.searchAgainButton.addEventListener('click', (e) => {
          e.preventDefault();
          
          this.resetResults();
        });
        
        this.loadMoreButton.addEventListener('click', this.loadMore.bind(this));

        window.addEventListener('popstate', this.popStateHandler);
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.popStateHandler);
      }
      
      async submit(e) {
        e.preventDefault();
        
        const form = e.currentTarget;
        const target = form.querySelector('button');
        const formData = new FormData(form);
        
        if (!this.resultsContainer.querySelector('.scp-search__results-list .scp-search__result-box--skeleton')) {
          this.resultsContainer.querySelector('.scp-search__results-list').innerHTML = '';
        }
        this.filter['query'] = formData.get('query');
        this.filter['zip'] = formData.get('zip');
        
        this.setButtonState(target, 'busy');
        this.resetErrorMessage(form);
        
        await this.fetchResults().then(async (response) => {
          let searchParams = new URLSearchParams(window.location.search);
          const searchParamsSize = searchParams.size;

          try {
            await this.fetchResultMarkup(response);
            this.updateResultsCount();
            
            Object.keys(this.filter).forEach(key => {
              if (this.filter[key] && this.filter[key] !== '') {
                searchParams.set(key, this.filter[key]);
              } else {
                searchParams.delete(key);
              }
            });
            window.history.pushState(null, null, window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString());
          } catch(err) {
            console.error(err);
            this.resetResults();
            this.setErrorMessage(form, this.errorMessage);
          }
          this.setButtonState(target, 'idle');
          if (searchParamsSize == 0) {
            this.scrollIntoView();
          } 
        });
      }
      
      async loadMore(e) {
        e.preventDefault();
        
        const parent = e.currentTarget.parentElement;
        const target = e.currentTarget;
        this.setButtonState(target, 'busy');
        this.resetErrorMessage(parent);
        
        await this.fetchResults().then(async (response) => {
          try {
            await this.fetchResultMarkup(response);
            this.updateResultsCount();
          } catch(err) {
            console.error(err);
            this.setErrorMessage(parent, this.errorMessage);
          }
          this.setButtonState(target, 'idle');
        });
      }
      
      setButtonState(target, state = 'idle') {
        if (state === 'busy') {
          target.setAttribute('disabled', 'true');
          target.setAttribute('aria-disabled', 'true');
          target.setAttribute('aria-busy', 'true');
        } else {
          target.removeAttribute('disabled');
          target.removeAttribute('aria-disabled');
          target.removeAttribute('aria-busy');
        }
      }
      
      updateResultsCount() {
        this.loadMoreButton.removeAttribute('hidden');
        if (this.totalCount == 0 || this.totalCount > 1) {
          this.totalCountElement.innerText = `${this.totalCount} ${this.totalCountElement.dataset.plural}`;
        } else {
          this.totalCountElement.innerText = `${this.totalCount} ${this.totalCountElement.dataset.singular}`;
        }
        
        this.currentCountElement.innerText = this.currentCountElement.dataset.text.replace('[[currentCount]]', this.currentCount).replace('[[totalCount]]', this.totalCount);
        
        if (this.pageInfo.hasNextPage === false) {
          this.loadMoreButton.setAttribute('disabled', true);
          this.loadMoreButton.setAttribute('hidden', true);
          this.currentCountElement.setAttribute('hidden', true);
        }
      }
      
      fetchResults() {
        return fetch(`${window.Shopify.routes.root}a/portal/public/graphql`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            query: `
              query($filter: SalesRepresentativesPublicFilterInput, $first: Int, $after: String) {
                salesRepresentativesPublic(filter: $filter, first: $first, after: $after) {
                  edges {
                    node {
                      sanitizedSlug
                    }
                  }
                  pageInfo {
                    hasNextPage
                    endCursor
                  }
                  totalCount
                }
              }
            `,
            variables: {
              filter: this.filter,
              after: this.pageInfo?.endCursor,
              first: parseInt(this.resultLimit),
            }
          })
        })
          .then(res => {
            if (!res.ok) throw new Error('API Error');
            return res.json();
          })
          .catch(err => {
            if (this.consultantNameForm.querySelector('button').getAttribute('aria-busy')) {
              this.setButtonState(this.consultantNameForm.querySelector('button'), 'idle');
            }
            if (this.consultantZipForm.querySelector('button').getAttribute('aria-busy')) {
              this.setButtonState(this.consultantZipForm.querySelector('button'), 'idle');
            }
          });
      }
      
      async fetchResultMarkup(response) {
        if (!response?.data?.salesRepresentativesPublic?.edges) throw new Error('Invalid API response');
        
        const data = response?.data?.salesRepresentativesPublic?.edges?.map(edge => edge?.node?.sanitizedSlug) ?? [];
        const totalCount = response?.data?.salesRepresentativesPublic?.totalCount;
        
        const settledPromises = await Promise.allSettled(data.map(async (handle) => {
          const html = await fetch(`${window.Shopify.routes.root}pages/sales-consultant/${handle}?sections=scp-search-result`,
            {
              method: 'GET'
            })
              .then(res => res.json())
              .then(res => {
                if (!res['scp-search-result']) throw new Error('No result markup found');
                
                const parser = new DOMParser();
                const html = parser.parseFromString(res['scp-search-result'], 'text/html').getElementById('shopify-section-scp-search-result').innerHTML;
              
                return html;
              })
              .catch(err => {
                throw err;
              });
            return html;
        }));
        
        if (settledPromises.filter(result => result.status == 'fulfilled').length !== data.length) {
          throw new Error('Fetching results markup failed');
        }
        if (this.resultsContainer.querySelector('.scp-search__results-list .scp-search__result-box--skeleton')) {
          this.resultsContainer.querySelector('.scp-search__results-list').innerHTML = '';
        }
        this.resultsContainer.querySelector('.scp-search__results-header').classList.remove('scp-search__results-header--searching');
        this.resultsContainer.querySelector('.scp-search__results-list').insertAdjacentHTML('beforeend', settledPromises.map(result => result.value).join(''));
        this.currentCount += settledPromises.length;
        this.totalCount = totalCount;
        this.pageInfo = response?.data?.salesRepresentativesPublic?.pageInfo;
        this.resultsContainer.removeAttribute('hidden');
        this.searchFormContainer.setAttribute('hidden', true);

        if (this.currentCount === 0) {
          this.resultsContainer.querySelector('.scp-search__results-list').insertAdjacentHTML('beforeend', this.noResultsTemplate.innerHTML);
        }
      }
      
      resetResults() {
        this.consultantNameForm.querySelector('input').value = '';
        this.consultantZipForm.querySelector('input').value = '';
        this.consultantNameForm.querySelector('button').setAttribute('disabled', true);
        this.consultantZipForm.querySelector('button').setAttribute('disabled', true);
        this.searchFormContainer.removeAttribute('hidden');
        this.resultsContainer.setAttribute('hidden', true);
        this.loadMoreButton.removeAttribute('disabled');
        this.loadMoreButton.removeAttribute('hidden');
        this.resetErrorMessage(this.loadMoreButton.parentElement);
        this.currentCountElement.removeAttribute('hidden');
        this.totalCount = 0;
        this.currentCount = 0;
        this.totalCountElement.innerText = '';
        this.currentCountElement.innerText = '';
        this.filter = {};
        this.pageInfo = null;
        this.resultsContainer.querySelector('.scp-search__results-list').innerHTML = '';

        window.history.replaceState(null, null, window.location.protocol + '//' + window.location.host + window.location.pathname);
      }
      
      setErrorMessage(target, message) {
        const errorMessage = target.querySelector('.scp-search__error-message');
        if (errorMessage && message) {
          errorMessage.innerText = message;
        }
      }
      
      resetErrorMessage(target) {
        const errorMessage = target.querySelector('.scp-search__error-message');
        if (errorMessage) {
          errorMessage.innerText = '';
        }
      }

      onPopState(e) {
        this.resetResults();
      }
    }
  );
}
